import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=a322554c&scoped=true&"
import script from "./page-header.vue?vue&type=script&lang=js&"
export * from "./page-header.vue?vue&type=script&lang=js&"
import style0 from "./page-header.vue?vue&type=style&index=0&id=a322554c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a322554c",
  null
  
)

export default component.exports